import React, { Component } from 'react';
import Layout from '../components/organisms/Layout';
import ChatHolder from '../components/organisms/ChatHolder';

class DeconstructingTransparency extends Component {

  componentDidMount() {
    const clientID = 'ZDAzNTBiZmUtM2Q4Yi00MDdkLWI2NzAtYjU0NTc1YzEyYjA4fDk3Y2NiMjM1LWYzYzktNDAwMS05ZGM3LWViZGI3NjNlMjYzYg=='

    const script = document.createElement( 'script' );
    script.src = `https://widget.flow.ai/w/${clientID}/flow-webclient-1.1.2.min.js`;
    script.async = true;

    const config = document.createElement( 'script' );
    config.type = 'text/javascript';
    config.async = true;
    config.innerHTML = `
      window.__flowai_webclient_storage = 'session';
      window.__flowai_webclient_autoOpen = true;
      window.__flowai_webclient_embed = 'chat-holder';
      window.__flowai_webclient_font = {
        family: 'freight-sans-pro',
        url: 'https://use.typekit.net/jqg2flg.css'
      }
      window.__flowai_webclient_autoTriggerEvent = 'SHOW_WELCOME';`;

    document.body.appendChild( config );
    document.body.appendChild( script );
  }

  render() {
    return (
      <Layout
        pageTitle="Deconstructing Transparency"
        mins={10}
        bgImg="dt-bits.png">
        <ChatHolder/>
      </Layout>
    )
  }
};

export default DeconstructingTransparency;



